function doesShippingCouponApply (couponCourier, selectedCourier) {
  if (!couponCourier || !selectedCourier) return false

  return couponCourier === 'all' || couponCourier === selectedCourier
}

function calculateShippingCouponDiscount (shippingPrice, discountType, discountValue) {
  const price = Math.max(0, Number(shippingPrice) || 0)
  const value = Math.max(0, Number(discountValue) || 0)
  const requestedDiscount = discountType === 'fixed'
    ? value
    : (price * value) / 100

  return Math.min(price, Math.round(requestedDiscount))
}

module.exports = {
  doesShippingCouponApply,
  calculateShippingCouponDiscount
}
